// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mask-mMlatB{background:rgba(255,255,255,.9);flex-direction:column;justify-content:center;align-items:center;row-gap:16px;width:100%;height:100%;display:flex;position:absolute;top:0;left:0}.text-lbSaE4{color:rgba(6,7,9,.5);font-size:14px}.progress-_8XJZG{width:250px;height:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mask": `mask-mMlatB`,
	"text": `text-lbSaE4`,
	"progress": `progress-_8XJZG`
};
export default ___CSS_LOADER_EXPORT___;
